import { EditorMessageType } from 'src/types';

export const getHumanMessage = (inputValue: string) => {
  return {
    content: inputValue,
    type: EditorMessageType.HUMAN,
  };
};
